// extracted by mini-css-extract-plugin
export default {"tableContainerHeader":"invoiceDetailTable_tableContainerHeader__UkKzF","tableFooter":"invoiceDetailTable_tableFooter__ZX1N2","noRecFound":"invoiceDetailTable_noRecFound__xhdlN"};